<template>
  <div class="form-title">
    <h6 class="form-title">{{ text }}</h6>
    <hr class="form-title">
  </div>
</template>

<script>
export default {
  name: 'form-title',
  props: ['text'],
  // data () {
  //   return {
  //     info: null
  //   }
  // },
  mounted () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
h6.form-title {
  /*color: red;*/
  /*font-weight: 800;*/
}
div.form-title {
  margin-top: 50px;
}
hr.form-title {
  margin-top: 4px;
}
</style>
